module.exports = require("compression");


//////////////////
// WEBPACK FOOTER
// external "compression"
// module id = 5
// module chunks = 0